import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CarrierImportVerificationResult } from './carrier-import-verification-result.model';
import { URL_BASE } from '../../core/constants';
import { HttpUtils } from '../../shared/http-utils';
import { map, mergeMap } from 'rxjs/operators';
import { CarrierImportVerificationRowResult } from './carrier-import-verification-row-result';
import { FileService } from '../../shared/services/file.service';

@Injectable()
export class CarrierImportService {
  private CARRIER_IMPORT_URI = 'carrier-import';

  constructor(
    private http: HttpClient,
    private fileService: FileService
  ) {
  }

  public verifyData(file: File): Observable<CarrierImportVerificationResult> {
    const url = `${URL_BASE}/api/${this.CARRIER_IMPORT_URI}/verify-data`;
    const headers = HttpUtils.createHeaders();

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(url, formData, {headers})
      .pipe(map(result => CarrierImportVerificationResult.fromDto(result)));
  }

  public downloadOkCarriers(carrierRows: CarrierImportVerificationRowResult[]): Observable<any> {
    const url = `${URL_BASE}/api/${this.CARRIER_IMPORT_URI}/download`;
    const headers = HttpUtils.createHeaders();
    headers.set('Accept', 'text/plain');

    return this.http.post(url, CarrierImportVerificationRowResult.toDtos(carrierRows), {headers, responseType: 'blob', observe: 'response' })
      .pipe(mergeMap((result: HttpResponse<Blob>) => this.fileService.saveToFileSystem(result)))
  }
}
